Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.OnOffDutyAlert = {

  template() {
    return {
      tag: 'div',
        items: [
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: Monet.I18n.getResourcesByKey('event.check.onOffDutyAlert.days'),
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'days',
                },
              },
              {
                items: [
                {
                  tag: 'select',
                    attributes: {
                      multiple: 'true',
                      id: 'onOffDutyAlert_days',
                    },
                  },
                ],
                attributes: {
                  class: 'controls',
                },
              },
            ],
            attributes: {
              class: 'control-group',
            },
          },
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: Monet.I18n.getResourcesByKey('event.check.onOffDutyAlert.timeToCheck'),
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'timeToCheck',
                },
              },
              {
                items: [
                    {
                      tag: 'input',
                      attributes: {
                        type: 'text',
                        name: 'time_to_check',
                        'id': 'time_to_check',
                        'class': 'timeField',
                        'autocomplete': 'off',
                      },
                    },
                  ],
                  attributes: {
                    class: 'controls',
                  },
                },
              ],
              attributes: {
                class: 'control-group on-off-duty-alert-time'
              }
            },
           {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: Monet.I18n.getResourcesByKey('event.check.onOffDutyAlert.typeEvent'),
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'typeEvent',
                },
              },
              {
                tag: 'select',
                items: [
                  {
                    tag: 'option',
                    'html': Monet.I18n.getResourcesByKey('event.check.onOffDutyAlert.onDuty'),
                    'attributes': {
                      "value": 'ON_DUTY',
                    },
                  },
                  {
                    tag: 'option',
                    html: Monet.I18n.getResourcesByKey('event.check.onOffDutyAlert.offDuty'),
                    'attributes': {
                      "value": 'OFF_DUTY',
                    },
                  },
                ],
                attributes: {
                  name: 'type_event',
                  'id': 'type_event',
                  class: 'modelAttribute selectField mandatory',
                },
              },
            ],
            attributes: {
              class: 'controls',
            },
          },
        ],
        attributes: {
          class: 'control-group',
        },
      };
    },

  assignParameter(jsonParam) {
    let daysOfWeek = [
      Monet.I18n.getResourcesByKey('weekdays.sunday'),
      Monet.I18n.getResourcesByKey('weekdays.monday'),
      Monet.I18n.getResourcesByKey('weekdays.tuesday'),
      Monet.I18n.getResourcesByKey('weekdays.wednesday'),
      Monet.I18n.getResourcesByKey('weekdays.thursday'),
      Monet.I18n.getResourcesByKey('weekdays.friday'),
      Monet.I18n.getResourcesByKey('weekdays.saturday')
    ];

    let selected, timeStart, typeEvent, daysOfWeekSelected;

    if(jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      timeStart = jsonParam.timeStart;
      typeEvent = jsonParam.typeEvent;
      daysOfWeekSelected = jsonParam.daysOfWeek;
    }

    daysOfWeek.forEach((day, index) => {
        if (daysOfWeekSelected && daysOfWeekSelected.indexOf(index.toString()) !== -1) {
            selected = true;
        }
        $('#onOffDutyAlert_days').append(new Option(day, index, false, selected));
        selected = false;
    });

    $('#time_to_check').timepicker({
      hourGrid: 4,
      minuteGrid: 10,
      showSecond: false,
      timeFormat: new Monet.Date.GeneralFunctions().getTimeFormatWithSeconds(),
    })
    .val(timeStart)
    .on("focus", () => {
        $('.ui-datepicker-current').css('display', 'block');
    });

    $('#type_event').val(typeEvent);
  },

  retrieveParameter() {
    const daysOfWeekSelected = [];
    const daysOfWeekSize = $('#onOffDutyAlert_days option:selected').length;
    let c = 0;

    for (let x = 0; x < daysOfWeekSize; x++) {
      const value = $('#onOffDutyAlert_days option:selected')[x].value;

      if (value !== null) {
          daysOfWeekSelected[c] = value;
        c++;
      }
    }

    return JSON.stringify({
      daysOfWeek: daysOfWeekSelected,
      timeStart: $('#time_to_check').val(),
      typeEvent: $('#type_event').val()
    });
  },
};
